// Conversion d'un montant en lettres francaises (FCFA).
// Portee du design easy-compta-design (invoiceUtils) : le backend reste
// la source de verite pour le montant imprime sur la facture.

const UNITS = ['', 'un', 'deux', 'trois', 'quatre', 'cinq', 'six', 'sept', 'huit', 'neuf'];
const TEENS = ['dix', 'onze', 'douze', 'treize', 'quatorze', 'quinze', 'seize',
  'dix-sept', 'dix-huit', 'dix-neuf'];
const TENS = ['', 'dix', 'vingt', 'trente', 'quarante', 'cinquante', 'soixante',
  'soixante-dix', 'quatre-vingt', 'quatre-vingt-dix'];

function convertGroup(num) {
  let result = '';
  const h = Math.floor(num / 100);
  const r = num % 100;
  if (h > 0) {
    if (h === 1) result += 'cent';
    else {
      result += UNITS[h] + ' cent';
      if (r === 0) result += 's';
    }
    if (r > 0) result += ' ';
  }
  if (r > 0) {
    if (r < 10) result += UNITS[r];
    else if (r < 20) result += TEENS[r - 10];
    else {
      const t = Math.floor(r / 10);
      const u = r % 10;
      if (t === 7) result += 'soixante-' + (u === 1 ? 'et-onze' : TEENS[u]);
      else if (t === 9) result += 'quatre-vingt-' + TEENS[u];
      else if (t === 8) result += 'quatre-vingt' + (u === 0 ? 's' : '-' + UNITS[u]);
      else {
        result += TENS[t];
        if (u === 1) result += ' et un';
        else if (u > 1) result += '-' + UNITS[u];
      }
    }
  }
  return result.trim();
}

export function numberToWordsFr(n) {
  if (!n) return 'Zéro Franc CFA';
  const integerPart = Math.floor(Math.abs(n));
  const parts = [];
  const billions = Math.floor(integerPart / 1e9);
  const millions = Math.floor((integerPart % 1e9) / 1e6);
  const thousands = Math.floor((integerPart % 1e6) / 1000);
  const unitsGroup = integerPart % 1000;

  if (billions) parts.push(billions === 1 ? 'un milliard' : `${convertGroup(billions)} milliards`);
  if (millions) parts.push(millions === 1 ? 'un million' : `${convertGroup(millions)} millions`);
  if (thousands) parts.push(thousands === 1 ? 'mille' : `${convertGroup(thousands)} mille`);
  if (unitsGroup) parts.push(convertGroup(unitsGroup));

  const formatted = parts.join(' ').trim();
  return `${formatted.charAt(0).toUpperCase()}${formatted.slice(1)} Francs CFA`;
}

export function formatMontant(n) {
  return new Intl.NumberFormat('fr-FR').format(Math.round(n || 0));
}
